module.exports = __webpack_public_path__ + "static/media/snowfight.6d5209da.png";